import { defineMessages } from 'react-intl';

export const MeterDetail = defineMessages({
  directElectricityMeter: {
    id: 'app.common.meterDetails.directElectricityMeter',
    defaultMessage: 'Přímý elektroměr',
  },
  direct: {
    id: 'app.common.meterDetails.direct',
    defaultMessage: 'Přímý',
  },
  indirect: {
    id: 'app.common.meterDetails.indirect',
    defaultMessage: 'Nepřímý',
  },
  orientation: {
    id: 'app.common.meterDetails.orientation',
    defaultMessage: 'Montážní poloha',
  },
  gSize: {
    id: 'app.common.meterDetails.gSize',
    defaultMessage: 'Jmenovitý průtok G',
  },
  diameterNominal: {
    id: 'app.common.meterDetails.diameterNominal',
    defaultMessage: 'Dimenze DN',
  },
  layLength: {
    id: 'app.common.meterDetails.layLength',
    defaultMessage: 'Stavební délka',
  },
  flowRate: {
    id: 'app.common.meterDetails.flowRateUnit',
    defaultMessage: 'Průtok {unit}',
  },
  resistance: {
    id: 'app.common.meterDetails.resistance',
    defaultMessage: 'Odpor teploměrů',
  },
  installationPosition: {
    id: 'app.common.meterDetails.installationPosition',
    defaultMessage: 'Pozice průtokoměru',
  },
  equipmentCategory: {
    id: 'app.common.meterDetails.equipmentCategory',
    defaultMessage: 'Kategorie zařízení',
  },
  measurementCategory: {
    id: 'app.common.meterDetails.measurementCategory',
  },
});

export const MeterDetailContent = defineMessages({
  information: {
    id: 'app.common.information',
    defaultMessage: 'Informace',
  },
  coordinatesNotAvailable: {
    id: 'app.common.coordinatesNotAvailable',
    defaultMessage: 'Souradnice v mapě nejsou dostupné',
  },
  map: {
    id: 'app.common.map',
    defaultMessage: 'Mapa',
  },
  floorplanNotAvailable: {
    id: 'app.common.floorplanNotAvailable',
    defaultMessage: 'Floorplan neni dostupný',
  },
  floorplan: {
    id: 'app.common.floorplan',
    defaultMessage: 'Floorplan',
  },
  data: {
    id: 'app.common.data',
    defaultMessage: 'Data',
  },
  noDataSource: {
    id: 'app.MeterDetailContent.noDataSource',
    defaultMessage: 'Měřidlo nemá vyplněný dataSource',
  },
});

export const DecoderTab = defineMessages({
  channel: {
    id: 'app.common.channel',
    defaultMessage: 'Kanál',
  },
  date: {
    id: 'app.common.date',
    defaultMessage: 'Datum',
  },
  value: {
    id: 'app.common.value',
    defaultMessage: 'Hodnota',
  },
});

export const MeterDetailFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  updateData: {
    id: 'app.common.updateData',
    defaultMessage: 'Aktualizovat údaje',
  },
});

export const MeterDetailPage = defineMessages({
  meterDetail: {
    id: 'app.MeterDetailPage.meterDetail',
    defaultMessage: 'Detail měřidla',
  },
});

export const MeterHardwares = defineMessages({
  serialNumber: {
    id: 'app.common.serialNumberShortcut',
    defaultMessage: 'VČ {serialNumber}',
  },
});

export const MapTab = defineMessages({
  mapNotAvailable: {
    id: 'app.MapTab.mapNotAvailable',
    defaultMessage: ' Mapa pro toto měřidlo není k dispozici!',
  },
});

export const InformationTab = defineMessages({
  updatedAt: {
    id: 'app.common.lastUpdate',
    defaultMessage: 'Poslední aktualizace',
  },
  lastUpdate: {
    id: 'app.common.lastUpdate',
    defaultMessage: 'Poslední zpráva',
  },
  commodity: {
    id: 'app.common.commodity',
  },
  monitoredEntity: {
    id: 'app.common.monitoredEntity',
    defaultMessage: 'Název měřidla',
  },
  owner: {
    id: 'app.common.owner',
    defaultMessage: 'Vlastník',
  },
  serialNumber: {
    id: 'app.common.serialNumber',
    defaultMessage: 'Sériové číslo',
  },
  pasportDate: {
    id: 'app.common.datePasport',
    defaultMessage: 'Datum pasportu',
  },
  pasportBy: {
    id: 'app.common.pasportBy',
    defaultMessage: 'Pasportoval',
  },
  installationDate: {
    id: 'app.common.installationDate',
    defaultMessage: 'Datum instalace',
  },
  license: {
    id: 'app.common.license',
    defaultMessage: 'Typ licence',
  },
  installedBy: {
    id: 'app.common.installedBy',
    defaultMessage: 'Instaloval',
  },
  details: {
    id: 'app.common.details',
    defaultMessage: 'Detaily',
  },
  lorawanRssi: {
    id: 'app.common.lorawanRssi',
    defaultMessage: 'Signál LoRaWAN',
  },
  nbiotRssi: {
    id: 'app.common.nbiotRssi',
    defaultMessage: 'Signál NB-IoT',
  },
  unmeasured: {
    id: 'app.common.unmeasured',
    defaultMessage: 'Nezměřena',
  },
  accessibility: {
    id: 'app.common.accessibility',
    defaultMessage: 'Přístupnost',
  },
  manufactured: {
    id: 'app.Select.manufacturedLabel',
    defaultMessage: 'Rok výroby měřidla',
  },
  calibrated: {
    id: 'app.Select.calibratedLabel',
    defaultMessage: 'Rok cejchování měřidla',
  },
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
  group: {
    id: 'app.common.group',
    defaultMessage: 'Skupina',
  },
  noReadingGroup: {
    id: 'app.common.noReadingGroup',
    defaultMessage: 'Žádné skupiny měřidel',
  },
  assignedHardware: {
    id: 'app.common.assignedHardware',
    defaultMessage: 'Přiřazený hardware',
  },
});
